// extracted by mini-css-extract-plugin
module.exports = {"dueDateItem":"paymentusagedetail_dueDateItem__1oWjl","btnCol":"paymentusagedetail_btnCol__1S1TN"};